// import React from 'react';

// const OurBurdenBearer = (props) => {
//   return (
//     <div>
//       <h2>Our Burden Bearer</h2>
//       <p class="strong">Psalm 55:22 “ Cast thy burden upon the LORD, and he shall sustain thee: he shall never suffer the righteous to be moved”</p>
//       <p>As we go through life we each accumulate burdens. Burdens of one kind or another, at some time or another. Often these burdens weigh us down. Many of God’s children are burdened at the moment. Burdened with worry. Burdened with anxiety. Burdened with fear.</p>
//       <p>David was burdened in this Psalm. However he exhorts us to “Cast [our] burden upon the LORD” The word “cast” means ‘to throw’, ‘to hurl’, ‘to shed’. We’ve all stood on the shore and threw a great stone into the ocean. That’s the idea. The Lord calls His children to hurl their burden onto Him. Not only will the Lord bear our burdens, but the Psalmist tells us He will sustain our Souls and steady our steps.</p>
//       <p class="lead">Naturally, we all find it hard to let go of our burdens.</p>
//       <p>C.H. Spurgeon tells the story of a man who was walking along a road with a pack on his back. He was growing weary and was therefore glad when a gentleman came along in a carriage and asked him to take a seat with him. The gentleman noticed that he kept his pack strapped to his shoulders, and so said, “Why do you not put your pack down?” “Why, sir,” said the traveler, “I did not venture to impose. It was very kind of you to take me up, and I could not expect you to carry my pack as well.” “Why,” said his friend, “do you not see that whether your pack is on your back or off your back, I have to carry it?”</p>
//       <p>The lesson is, whether we worry or not, the Lord cares for us and He will carry us, and our burdens, through every difficult day.</p>
//       <p>1 Peter 5:7 “Casting all your care upon him; for he careth for you."</p>
//     </div>
//   )
// }

// export default OurBurdenBearer;
import React from 'react';

const OurBurdenBearer = (props) => {
  return (
    <div>
      <div className="card1">
        <h2>Our Jerusalem</h2>
        <p class="text">A message about our calling to serve and impact our local community.</p>
        <iframe src="https://www.youtube.com/embed/njGKih7dldw" allowfullscreen></iframe>
      </div>

      <div className="card2">
        <h2>Power of Prayer</h2>
        <p>A sermon exploring the importance and effectiveness of prayer in our lives.</p>
        <iframe src="https://www.youtube.com/embed/mutf_xAfCQI" allowfullscreen></iframe>
      </div>

      <div className="card3">
        <h2>Designed to Serve</h2>
        <p>Discovering our purpose and mission as individuals and as a church community.</p>
        <iframe src="https://www.youtube.com/embed/hKHivCc3ikA" allowfullscreen></iframe>
      </div>

      <div className="card4">
        <h2>Church - Victory in the Written CHRIST</h2>
        <p>Exploring the victory we have through Christ and His written word.</p>
        <iframe src="https://www.youtube.com/embed/D_o0VLVb8T4" allowfullscreen></iframe>
      </div>
    </div>
  )
}

export default OurBurdenBearer;

